import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';

// Componente AdvertisementManager (puedes moverlo a un archivo separado después)
const PositionedDialog = styled(Dialog)(({ position }) => ({
  '& .MuiDialog-paper': {
    position: 'fixed',
    margin: 0,
    maxWidth: 'none',
    
    // Estilos para LEFT
    ...(position === 'LEFT' && {
      left: 0,
      top: 0,
      height: '100%',
      // Mobile (small) - 50%
      width: '50%',
      // Tablet (medium) - 40%
      '@media (min-width: 600px)': {
        width: '25%',
      },
      // Desktop (large) - 25%
      '@media (min-width: 900px)': {
        width: '15%',
      },
    }),
    
    // Estilos para RIGHT
    ...(position === 'RIGHT' && {
      right: 0,
      top: 0,
      height: '100%',
      width: '50%',
      '@media (min-width: 600px)': {
        width: '25%',
      },
      '@media (min-width: 900px)': {
        width: '15%',
      },
    }),
    
    // Estilos para TOP
    ...(position === 'TOP' && {
      top: 0,
      left: 0,
      right: 0,
      height: '30%',
      '@media (min-width: 600px)': {
        height: '20%',
      },
      '@media (min-width: 900px)': {
        height: '15%',
      },
    }),
    
    // Estilos para BOTTOM
    ...(position === 'BOTTOM' && {
      bottom: 0,
      left: 0,
      right: 0,
      height: '30%',
      '@media (min-width: 600px)': {
        height: '20%',
      },
      '@media (min-width: 900px)': {
        height: '15%',
      },
    }),
    
    // Estilos para CENTER
    ...(position === 'CENTER' && {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '80vw',
      maxWidth: '80vw',
      height: '70vh',  
      maxHeight: '70vh',
      '@media (min-width: 600px)': {
        width: '50vw',
        maxWidth: '50vw',
        height: '50vh',  
        maxHeight: '50vh',
      },
      '@media (min-width: 900px)': {
        width: '50vw',
        maxWidth: '50vw',
        height: '70vh',  
        maxHeight: '70vh',
      },
    }),

  },
}));

const AdvertisementManager = ({ advertisements, advertisementTypeToShow, user }) => {
  const [advertisement, setAdvertisement] = useState(null);
  const [open, setOpen] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  // const [AdvertisementTraceId, setAdvertisementTraceId] = useState(0);

  const countdownRef = useRef(null);
  const navigate = useNavigate();

  const AdvertisementCodeIdRef = useRef(null);
  const advertisementTraceIdRef = useRef(null);
  const advertisementTraceCloseManual = useRef(false);
  const timetotal = useRef(false);

  function selectRandomAdvertisement(advertisements) {
    // 1. Calcular pesos combinados (Rating - UsagedPerClient)
    const weightedAds = advertisements.map(ad => {
      // Ajusta estos factores según necesites
      const ratingWeight = ad.Rating;           // Peso positivo (mayor rating = más probabilidad)
      const usagePenalty = ad.UsagedPerClient;   // Peso negativo (más vistas = menos probabilidad)
      
      // Fórmula de peso ajustado (puedes modificar esta fórmula)
      const adjustedWeight = Math.max(1, ratingWeight - (usagePenalty * 0.1)); // *0.1 para no penalizar demasiado
      
      return {
        ...ad,
        weight: adjustedWeight
      };
    });
  
    // 2. Suma total de todos los pesos
    const totalWeight = weightedAds.reduce((sum, ad) => sum + ad.weight, 0);
  
    // 3. Selección aleatoria ponderada
    let random = Math.random() * totalWeight;
    let selectedAd = null;
  
    for (const ad of weightedAds) {
      random -= ad.weight;
      if (random <= 0) {
        selectedAd = ad;
        break;
      }
    }
  
    return selectedAd || weightedAds[0]; // Fallback por si acaso
  }

    // Función para seleccionar un anuncio aleatorio ponderado por Rating
  const selectFilterAdvertisement = (ads) => {
      const nowLocal  = new Date();
      const currentweekDay = nowLocal.getDay(); // 0 (Domingo) a 6 (Sábado)
      const currentHour = nowLocal.getHours(); // 0-23
      const currentDay = nowLocal.getDate(); // 0-31
      const currentDate = new Date(nowLocal .getFullYear(), nowLocal .getMonth(), nowLocal .getDate());
      const currentDateISO = 
      nowLocal.getFullYear() * 10000 + 
      (nowLocal.getMonth() + 1) * 100 + 
      nowLocal.getDate();
      // console.log("currentDay",currentDay);
      // console.log("currentweekDay",currentweekDay);
      // console.log("currentHour",currentHour);
      // console.log("currentDateISO",currentDateISO);

    const plpAds = ads.filter(ad => {
      const startDate = new Date(ad.StartDate);
      const endDate = new Date(ad.EndDate);

      const startDateISO =  (startDate.getUTCFullYear() * 10000) + 
                            (startDate.getUTCMonth() + 1) * 100 + 
                            startDate.getUTCDate();
      const endDateISO =  (endDate.getUTCFullYear() * 10000) + 
                            (endDate.getUTCMonth() + 1) * 100 + 
                            endDate.getUTCDate();

        // Verificar si el anuncio tiene recurrencia definida
      const hasRecurrence = ad.Recurrence && ad.Recurrence.DaysOfWeek && ad.Recurrence.HoursOfDay;
      // console.log("ad.StartDate",startDateISO);
      // console.log("ad.EndDate",endDateISO);
      // Verificar condiciones básicas
      const basicConditions = ad.AdvertisementTypeToShow === advertisementTypeToShow && 
          ad.Status === "ACTIVE" && startDateISO <= currentDateISO && currentDateISO <= endDateISO;
          // console.log('code: ', ad.Code);
          // console.log('basicConditions: ', basicConditions);
      // Si no tiene recurrencia, solo aplicar condiciones básicas
      if (!hasRecurrence) return basicConditions;


      // Si tiene recurrencia, verificar día y hora
      return (
        basicConditions &&
        ad.Recurrence.DaysOfWeek.includes(currentweekDay) &&
        ad.Recurrence.HoursOfDay.includes(currentHour)
      );
    });

    if (plpAds.length === 0) return null;
    console.log('plpAds: ', plpAds);
  const ad = selectRandomAdvertisement(plpAds);
  console.log('Ad: ', ad);

    return ad;
  };

  const saveAdvertisementTrace = async (TraceId, EventType, usercode, AdvertisementCode, Progress) => {
    const traceData = {
      TraceId: TraceId,
      EventType: EventType, // Puede venir como parámetro
      UserId: usercode, // Ahora viene de los parámetros
      AdvertisementCode: AdvertisementCode == null ? "" : AdvertisementCode.toString(), // Ahora viene de los parámetros
      Progress : Progress
    };
    console.log("trace:", traceData);
    try {
      // console.log("URL:", process.env.REACT_APP_GET_ADVERTISEMENT_TRACE_UPDATE_URL);
      // process.env.REACT_APP_GET_ADVERTISEMENT_URL
      // const response = await fetch("https://localhost:31301/api/AdvertisementTraceView/Update", {
      const response = await fetch(process.env.REACT_APP_GET_ADVERTISEMENT_TRACE_UPDATE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(traceData),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      // console.log("Trace guardado:", response.json());
    } catch (error) {
      console.log("Error saving trace:", error);
    }
  };

  const handleAdClick = () => {
    // 1. Cierra el diálogo inmediatamente
    advertisementTraceCloseManual.current = true;
    saveAdvertisementTrace(advertisementTraceIdRef.current.toString(), 'CLOSE_CLIC', user.clientCode, AdvertisementCodeIdRef.current, 0);
    // cerrar el diálogo
    setOpen(false);



    

    setShowCloseButton(false);
    // 2. Abre el enlace (con retraso para mejor UX)
    setTimeout(() => {
      if (advertisement?.URLRedirect) {
        const redirectUrl = new URL(advertisement.URLRedirect, window.location.origin);

        // Si el origen del enlace es diferente al actual => externa
        if (redirectUrl.origin !== window.location.origin) {
          window.open(
            redirectUrl.href,
            '_blank',
            'noopener,noreferrer'
          );
        } else {
          navigate(redirectUrl.pathname + redirectUrl.search + redirectUrl.hash);
        }
      }
    }, 200); // 200ms es imperceptible pero evita bloqueo de pop-ups
  };
  
  const handleCloseAuto = (event, reason) => {
    console.log('handleCloseAuto', advertisementTraceCloseManual.current);
    if (advertisementTraceCloseManual.current === true) return; // Evita el cierre automático si se cerró manualmente
    saveAdvertisementTrace(advertisementTraceIdRef.current.toString(), 'CLOSE_AUTO', user.clientCode, AdvertisementCodeIdRef.current, 0);

    setOpen(false);
    setShowCloseButton(false);
  };


  const handleClose = (event, reason) => {
    advertisementTraceCloseManual.current = true;
    saveAdvertisementTrace(advertisementTraceIdRef.current.toString(), 'CLOSE_MANUAL', user.clientCode, AdvertisementCodeIdRef.current, 0);

    setOpen(false);
    setShowCloseButton(false);
  };

   // Limpiar intervalos al desmontar
   useEffect(() => {
    return () => {
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
    };
  }, []);


   useEffect(() => {
    // if (advertisementTraceIdRef.current !== null) return; 
    if (!advertisements || advertisements.length === 0) return;

    const selectedAd = selectFilterAdvertisement(advertisements);
    if (!selectedAd) return;

    setAdvertisement(selectedAd);

    const nowLocal  = new Date();
    const TraceId =  nowLocal.getFullYear() * 10000000000000 + 
    (nowLocal.getMonth() + 1) * 100000000000 + 
    nowLocal.getDate() * 1000000000 +
    nowLocal.getHours() * 10000000 + 
    nowLocal.getMinutes() * 100000 + 
    nowLocal.getSeconds() * 1000 + 
    nowLocal.getMilliseconds();



    // if (advertisementTraceIdRef.current == null)
    // {
    //     advertisementTraceIdRef.current = TraceId; // constante
    // }
    // console.log('AdvertisementTraceId-XXX',advertisementTraceIdRef.current);
    advertisementTraceCloseManual.current = false;
    advertisementTraceIdRef.current = TraceId; // constante
    AdvertisementCodeIdRef.current = selectedAd.Code; // constante
    console.log('AdvertisementTraceId',TraceId);
    // console.log('AdvertisementCode',AdvertisementCode);
    // console.log('selectedAd',selectedAd);
    // console.log('user',user);
    // console.log('TraceId',TraceId);
    saveAdvertisementTrace(TraceId.toString(), 'OPEN', user.clientCode, selectedAd.Code, 0);

    const timeOpen = selectedAd.TimeOpen !== null ? selectedAd.TimeOpen * 1000 : 10000;
    const timeClose = selectedAd.TimeClose !== null ? selectedAd.TimeClose * 1000 : 15000;
    const timeCloseAuto = selectedAd.TimeCloseAuto !== null ? selectedAd.TimeCloseAuto * 1000 : 20000;
    timetotal.current = (timeClose + timeCloseAuto) / 1000;
    console.log('timetotal',timetotal.current);
    
    const openTimer = setTimeout(() => {
      setOpen(true);
      // Tiempo total en segundos (TimeClose + TimeCloseAuto)
      const totalSeconds = Math.floor((timeClose + timeCloseAuto) / 1000);
      setRemainingTime(totalSeconds);
      //saveAdvertisementTrace(advertisementTraceIdRef.current.toString(), 'PROGRESS', user.clientCode, AdvertisementCodeIdRef.current, timetotal.current - totalSeconds);
      // Iniciar contador
      countdownRef.current = setInterval(() => {
        setRemainingTime(prev => {
          if (prev <= 1) {
            clearInterval(countdownRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      const closeButtonTimer = setTimeout(() => {
        setShowCloseButton(true);
        const autoCloseTimer = setTimeout(() => {
          handleCloseAuto();
        }, timeCloseAuto);

        return () => clearTimeout(autoCloseTimer);
      }, timeClose);

      return () => clearTimeout(closeButtonTimer);
    }, timeOpen);

    return () => {
      clearTimeout(openTimer);
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
    };
  }, [advertisements]);



  useEffect(() => {
    if (advertisementTraceCloseManual.current === true) return;
    // console.log('timetotal--',remainingTime);
    if (remainingTime > 0) {
      saveAdvertisementTrace(advertisementTraceIdRef.current.toString(), 'PROGRESS', user.clientCode, AdvertisementCodeIdRef.current, (timetotal.current - remainingTime + 1));
    } 
  }, [remainingTime]);

  const getImageUrl = () => {
    if (!advertisement) return null;
    
    const screenWidth = window.innerWidth;
    
    if (screenWidth >= 1024 && advertisement.URLImageLarge) {
      return advertisement.URLImageLarge;
    } else if (screenWidth >= 768 && advertisement.URLImageMedium) {
      return advertisement.URLImageMedium;
    } else if (advertisement.URLImageSmall) {
      return advertisement.URLImageSmall;
    }
    
    return null;
  };

  if (!advertisement) return null;

  const imageUrl = getImageUrl();
  if (!imageUrl) return null;

  return (
    <PositionedDialog
      position={advertisement.Position}
      open={open}
      onClose={(event, reason) => {
        // Solo permite cerrar con el botón (no con clic fuera o ESC)
        if (reason === 'closeButtonClick') {
          handleClose();
        }
      }}
      disableBackdropClick // Evita cerrar al hacer clic fuera
      disableEscapeKeyDown // Opcional: Evita cerrar con ESC
      BackdropProps={{
        sx: {
          pointerEvents: 'none' // Desactiva completamente los clicks en el backdrop
        }
      }}
      // disableEscapeKeyDown={!showCloseButton}
      // disableBackdropClick={!showCloseButton}
    >
      <DialogContent  
      sx={{ 
      p: 0,
      // Previene la propagación a nivel de contenedor
      '&:active, &:focus': { outline: 'none' }
    }}
    onClick={(e) => e.stopPropagation()} // Capa adicional de protección>
    >

       {/* <p><strong>Advertisement Trace ID:</strong> {advertisementTraceIdRef.current}</p>
       <p><strong>Tiempo restante:</strong> {remainingTime} segundos</p> */}
        <img 
              src={imageUrl} 
              alt={advertisement.AdvertisementName} 
              style={{ 
                width: '100%',
                height: '100%',
                objectFit: 'contain', // o 'cover' según lo que necesites
                cursor: 'pointer'
              }}
              onClick={(e) => {
                e.stopPropagation(); // Evita que el evento llegue al Dialog
                e.preventDefault(); 
                handleAdClick();
              }}
            />
        {/* Contador mejorado */}
        {open && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 16,
              right: 16,
              backgroundColor: 'rgba(0, 0, 0, 0.75)',
              color: 'white',
              borderRadius: '50%',
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.9rem',
              fontWeight: 'bold',
              boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}
          >
            {remainingTime}
          </Box>
        )}

        {showCloseButton && (
          <IconButton
            aria-label="close"
            onClick={(e) => {
              e.stopPropagation();
              // Marcamos el cierre como proveniente del botón
              handleClose({}, 'closeButtonClick');
            }}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogContent>
    </PositionedDialog>
  );
};

export default AdvertisementManager;